import FormSelect from './modules/_FormSelect';
import FormSelectSp from './modules/_FormSelectSp';

let formSelect = new FormSelect();
formSelect.bindProcess();


let formSelectSp =  new FormSelectSp();
formSelectSp.bindProcess();